import { putOrg } from '@moal/api'
import { useState } from 'react'
import 'react-quill/dist/quill.snow.css'
import { toastError, toastSuccess } from '../../../../utils/toast'
import Tooltip from '../../../Utilities/Tooltip'
import './styles.css'

const Copyright = ({ theOrg }) => {
  const [org, setOrg] = useState(theOrg)
  const [copyright, setCopyright] = useState(theOrg.copyright)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const updatedProduct = {
      ...org,
      copyright: copyright
    }

    const response = await putOrg({
      token: localStorage.getItem('authToken'),
      data: updatedProduct
    })
    if (response && response.status === 200) {
      toastSuccess('Copyright saved successfully')
      // products socket doesn't exist here so if you don't reload after updating it gets weird
      window.location.reload()
    } else {
      toastError('Failed to save Copyright')
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-2"
    >
      <div className="flex items-center gap-2">
        <h2>Copyright</h2>
        <Tooltip>Update your organization’s copyright text.</Tooltip>
      </div>
      <input
        id="url"
        name="url"
        defaultValue={copyright}
        onChange={(e) => setCopyright(e.target.value)}
        className="input block w-full"
        placeholder="Copyright"
      />
      <button type="submit" aria-label="Save" className="button-confirm w-fit">
        Save
      </button>
    </form>
  )
}

export default Copyright
